export default {
  SUCCESS: 'SUCCESS',
  IN_PROGRESS: 'IN_PROGRESS',
  ERROR: 'ERROR',
  INFORMATION: 'INFORMATION',
  CUSTOM: 'CUSTOM'
};
